module.exports = __webpack_public_path__ + "static/media/Pic10.f503238d.jpeg";